import React, { useEffect, useRef, useState } from "react";
import { IconUpload, IconX } from "@tabler/icons-react";
import { TbFilterX } from "react-icons/tb";
import { SlArrowRight } from "react-icons/sl";
import { SlArrowDown } from "react-icons/sl";
import { VscFilter } from "react-icons/vsc";
import toast from "react-hot-toast";
import { uploadExcelFile } from "../../../Api/BankStatement";
import { getAllBankApi } from "../../../Api/Bank";
import { BankStatementForm } from "./BankStatementForm";
import DonationModel from "./DonationModal";
import BalanceTransferModel from "./BalanceTransferModal";
import ExpenseModel from "./ExpenseModel";
import { ExpensesAssigned } from "./ExpensesAssigned";
import { BalanceTransferAssigned } from "./BalanceTransferAssigned";
import { DonationAssigned } from "./DonationAssigned";
import { getAllBankStatementApi } from "../../../Api/BankStatement";
import { getAssignedBalanceTransfer } from "../../../Api/BalanceTransfer";
import { getAssingedDonations } from "../../../Api/Donation";
import { getAssingedExpenses } from "../../../Api/Expense";
import { UnAssignBSIdBalanceTransfer } from "../../../Api/BalanceTransfer";
import { UnAssignBSIdExpense } from "../../../Api/Expense";
import { UnAssignBSIdDonations } from "../../../Api/Donation";
import { getBalanceTranferByBankStatement } from "../../../Api/BankStatement";
import { getDonationByBankStatement } from "../../../Api/BankStatement";
import { getExpenseByBankStatement } from "../../../Api/BankStatement";
import { useFilterContext } from "../FilterContext";
import { DonationDetailForm } from "../donationdetails/DonationDetailForm";
import { ExpenseForm } from "../ExpenseForm";
import { BalanceTransferForm } from "../BalanceTransferForm";
import { getDonationTPApi } from "../../../Api/DonationTypePurpose";
import { fetchDonationTypeApi } from "../../../Api/DonationTypes";
import { fetchPurposeApi } from "../../../Api/DonationPurpose";
import SideModal from "../../general/Sidemodal";
import { FaPlus } from "react-icons/fa";
import Filtermodal from "../../general/Filtermodal";
interface BankStatementInterface {
  cR_DR: string;
  typeId: number;
  id: string;
  bankId: string;
  transactionId: string | null;
  valueDate: string;
  txnPostedDate: string;
  chequeNo: string;
  description: string;
  crDr: string;
  transactionAmount: string;
  balance: string;
  date: string;
  isAssigned: boolean;
}
interface Option {
  id: string;
  value: string;
  label: string;
}
interface UserBank {
  id: string;
  label: string;
  name: string;
  accountNumber: number;
  donationPurposeId: string;
}
interface BankStatementProps {
  readyear: string;
  url: string;
}

const BankStatement = ({ url, readyear }: BankStatementProps) => {
  const [filterModal, setfilterModal] = useState(false);
  const [years, setyears] = useState<string[]>([]);
  const [months, setmonths] = useState<string[]>([]);
  const [search, setSearch] = useState("");
  const [bankStatements, setBankStatements] = useState<
    BankStatementInterface[]
  >([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [isUploadPanelOpen, setIsUploadPanelOpen] = useState(false);
  const [banks, setBanks] = useState<UserBank[]>([]);
  const [selectedbank, setSelectedBank] = useState<string>("");
  const [editingId, setEditingId] = useState<string | null>(null);
  const [file, setFile] = useState<File | null>(null);
  const [add, setAdd] = useState(false);
  const [currentTransactionAmount, setCurrentTransactionAmount] =
    useState<number>(0);
  const [donationAssignId, setDonationAssignId] = useState<string | null>(null);
  const [CrbalanceTransferAssignId, setCrBalanceTransferAssignId] = useState<
    string | null
  >(null);
  const [DrbalanceTransferAssignId, setDrBalanceTransferAssignId] = useState<
    string | null
  >(null);
  const [expenseAssignId, setExpenseAssignId] = useState<string | null>(null);
  const [showDonationModel, setShowDonationModel] = useState(false);
  const [showBalanceTransfer, setShowBalanceTransferModel] = useState(false);
  const [showExpensemodel, setShowExpenseModel] = useState(false);
  const ITEMS_PER_PAGE = 10;
  const { year, setyear, month, setmonth } = useFilterContext();
  const [openDropdownId, setOpenDropdownId] = useState<string>("");
  const [CRstatementId, setCRstatementId] = useState<string>("");
  const [DRstatementId, setDRstatementId] = useState<string>("");
  const [DebitedId, setDebitedId] = useState<string>("");
  const [CreditId, setCreditId] = useState<string>("");
  const [BalanceTransfer, setBalanceTransfer] = useState<any[]>([]);
  const [Donations, setDonations] = useState<any[]>([]);
  const [Expenses, setExpenses] = useState<any[]>([]);
  const [AssignedBalanceTransfer, setAssignedBalanceTransfer] = useState<any[]>(
    []
  );
  const [AssignedDonations, setAssignedDonations] = useState<any[]>([]);
  const [AssignedExpenses, setAssignedExpenses] = useState<any[]>([]);
  const [donationtype, setdonationtype] = useState<Option[]>([]);
  const [donationpurpose, setdonationpurpose] = useState<any[]>([]);
  const [donationTP, setdonationTp] = useState<any[]>([]);
  const [selectedCreateOption, setSelectedCreateOption] = useState<
    string | null
  >(null);
  const [matchingDonationTypes, setmatchingDonationTypes] = useState<any[]>([]);
  const [selectbankstatementId, setselectedbankstatementId] = useState<any>({});
  const [drbankstatementId, setdrbankstatementId] = useState<any>({});
  const [matchingDonationPurpose, setmatchingDonationPurpose] = useState<any>(
    {}
  );
  const [selectedDonationType, setSelectedDonationType] = useState({
    id: null,
    name: "",
  });
  const [createmodal, setcreatemodal] = useState(false);
  const [isAssigned, setIsAssigned] = useState<undefined | boolean>(undefined);
  const [crDrFilter, setCrDrFilter] = useState<string>("");
  const dropdownRef = useRef(null);


  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownId(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!url) return;
    
    const fetchData = async () => {
      try {
        const [banksData, Typedata, purposedata, donationtypepurpose] =
          await Promise.all([
            getAllBankApi(url),
            fetchDonationTypeApi(url),
            fetchPurposeApi(url),
            getDonationTPApi("donationTPId", url),
          ]);
        setBanks(banksData);
        setdonationtype(Typedata);
        setdonationpurpose(purposedata);
        setdonationTp(donationtypepurpose);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };
    fetchData();
  }, [url]);

  useEffect(() => {
    const startYear = parseInt(readyear);
    const currentYear = new Date().getFullYear();
    const generatedYears = Array.from(
      { length: currentYear - startYear + 1 },
      (_, i) => (startYear + i).toString()
    );
    const generatedMonths = Array.from({ length: 12 }, (_, i) =>
      (i + 1).toString()
    );
    setyears(generatedYears);
    setmonths(generatedMonths);
  }, [readyear]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchAllBankstatements(year, month, selectedbank, search, currentPage, ITEMS_PER_PAGE, crDrFilter);
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [selectedbank, search, currentPage]);

  useEffect(() => {
    if (search !== "") {
      setCurrentPage(1);
    }
  }, [search]);

  useEffect(() => {
    if (CRstatementId || DRstatementId) {
      fetchAssignedBalanceTransferData(CRstatementId, DRstatementId);
    }
    if (CRstatementId) {
      fetchAssignedDonationData(CRstatementId);
    }
    if (DRstatementId) {
      fetchExpenseData(DRstatementId);
    }

  }, [CRstatementId, DRstatementId]);

  useEffect(() => {
    if (banks.length > 0 && selectedbank === "") {
      fetchAllBankstatements("", "", "", search, 1, ITEMS_PER_PAGE, crDrFilter);
      setCurrentPage(1);
    }
  }, [banks, selectedbank]);

  useEffect(() => {
    if (CrbalanceTransferAssignId || DrbalanceTransferAssignId) {
      fetchBalanceTransferData(DrbalanceTransferAssignId, CrbalanceTransferAssignId, currentTransactionAmount);
    }
    if (donationAssignId) {
      fetchDonationData(donationAssignId, currentTransactionAmount);
    }
    if (expenseAssignId) {
      fetchExpensesData(expenseAssignId, currentTransactionAmount);
    }
  }, [donationAssignId, CrbalanceTransferAssignId, DrbalanceTransferAssignId, expenseAssignId]);

  const fetchAllBankstatements = async (
    year: string,
    month: string,
    bankId: string,
    searchTerm: string,
    pageNumber: number,
    pageSize: number,
    crDr?: string
  ) => {
    try {
      const response = await getAllBankStatementApi(url, {
        year,
        month,
        bankId: bankId || "", // Pass empty string for "All Banks"
        searchTerm,
        pageNumber,
        pageSize,
        isAssigned,
        crDr,
      });

      setBankStatements(response.bankStatements);
      const totalCount = response.totalCount || 0;
      setTotalPages(Math.ceil(totalCount / ITEMS_PER_PAGE) || 1);
    } catch (error) {
      toast.error("No data found for bank account or bank statements");
    }
  };

  const handleResetForm = () => {
    setSelectedBank("");
    setIsUploadPanelOpen(false);
  };

  const handleEditClick = (id: string) => {
    setEditingId(id);
    setAdd(true);
    setOpenDropdownId(null);
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!selectedbank || !file) return;

    const formData = new FormData();
    formData.append("formFile", file);
    formData.append("bank", selectedbank);

    try {
      await uploadExcelFile(formData);
      await fetchAllBankstatements(year, month, selectedbank, search, currentPage, ITEMS_PER_PAGE, crDrFilter);
      toast.success("Data saved successfully");
    } catch (error) {
      toast.error("Failed to process:");
      console.error("Upload error:", error);
    }
    handleResetForm();
  };

  const handleApply = () => {
    fetchAllBankstatements(year, month, selectedbank, search, 1, ITEMS_PER_PAGE, crDrFilter);
    setCurrentPage(1);
    setfilterModal(false);
  };

  const handleClear = () => {
    setSelectedBank("");
    setSearch("");
    setyear('');
    setmonth('');
    setIsAssigned(undefined);
    setCrDrFilter("");
    fetchAllBankstatements("", "", "", "", 1, ITEMS_PER_PAGE, "");
    setCurrentPage(1);
  };

  const handleAssignOptionClick = (
    option: string,
    id: string,
    amount: number,
    Crdr: string
  ) => {
    setOpenDropdownId(null);

    if (option === "donation") {
      setShowDonationModel(true);
      setDonationAssignId(id);
      setCurrentTransactionAmount(amount);
    }

    else if (option === "balanceTransfer") {
      if (Crdr === 'CR') {
        setCrBalanceTransferAssignId(id);
        setDrBalanceTransferAssignId(null);
      } else if (Crdr === 'DR') {
        setCrBalanceTransferAssignId(null);
        setDrBalanceTransferAssignId(id);
      }
      setCurrentTransactionAmount(amount);
      setShowBalanceTransferModel(true);

    }
    else if (option === "Expense") {
      setShowExpenseModel(true);
      setExpenseAssignId(id);
      setCurrentTransactionAmount(amount);
    }
  };

  const isAlreadyAssigned = (id: string): boolean => {
    const bankStatement = bankStatements.find(bs => bs.id === id);
    return bankStatement ? bankStatement.isAssigned : false;
  };

  const fetchBalanceTransferData = async (TransferFromBankStatementId: string, TransferToBankStatementId: string, amount: number) => {
    try {
      const response = await getBalanceTranferByBankStatement(TransferFromBankStatementId, TransferToBankStatementId, amount);
      setBalanceTransfer(response);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const fetchDonationData = async (Id: string, amount: number) => {
    try {
      const response = await getDonationByBankStatement(Id, amount);
      setDonations(response);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const fetchExpensesData = async (Id: string, amount: number) => {
    try {
      const response = await getExpenseByBankStatement(Id, amount);
      setExpenses(response);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const handleToggleExpand = async (id: string, type: string) => {
    if (type === "DR") {
      setDebitedId((prevId) => (prevId === id ? "" : id));
      setCreditId("");
    } else {
      setCreditId((prevId) => (prevId === id ? "" : id));
      setDebitedId("");
    }
  };

  const fetchAssignedBalanceTransferData = async (CRstatementId: string, DRstatementId: string) => {
    try {
      const response = await getAssignedBalanceTransfer(CRstatementId, DRstatementId);
      setAssignedBalanceTransfer(response);
    } catch (error) {
      console.error("Error fetching assigned balance transfer data", error);
    }
  };

  const fetchAssignedDonationData = async (CRstatementId: string) => {
    try {
      const response = await getAssingedDonations(CRstatementId);
      setAssignedDonations(response);
    } catch (error) {
      console.error("Error fetching assigned donation data", error);
    }
  };

  const fetchExpenseData = async (DRstatementId: string) => {
    try {
      const response = await getAssingedExpenses(DRstatementId);
      setAssignedExpenses(response);
    } catch (error) {
      console.error("Error fetching expense data", error);
    }
  };

  const toggleDropdown = (id: string) => {
    setOpenDropdownId(openDropdownId === id ? null : id);
  };

  const handleDeleteClick = async (id: string) => {

    const bankStatement = bankStatements.find(bs => bs.id === id);

    const transactionAmount = bankStatement ? parseFloat(bankStatement.transactionAmount) : 0;


    const cR_DR = bankStatement?.cR_DR;
    const isCR = cR_DR === 'CR';
    const isDR = cR_DR === 'DR';

    const actions = [];

    actions.push({
      data: AssignedBalanceTransfer,
      unassignFn: UnAssignBSIdBalanceTransfer,
      fetchFn: () => fetchAssignedBalanceTransferData(CRstatementId, DRstatementId),
      refetchFn: () => fetchBalanceTransferData(CRstatementId, DRstatementId, transactionAmount),
    });

    if (isCR) {
      actions.push({
        data: AssignedDonations,
        unassignFn: UnAssignBSIdDonations,
        fetchFn: () => fetchAssignedDonationData(id),
        refetchFn: () => fetchDonationData(id, transactionAmount),
      });
    }
    if (isDR) {
      actions.push({
        data: AssignedExpenses,
        unassignFn: UnAssignBSIdExpense,
        fetchFn: () => fetchExpenseData(id),
        refetchFn: () => fetchExpensesData(id, transactionAmount),
      });
    }
    const tasks = actions.map(
      async ({ data, unassignFn, fetchFn, refetchFn }) => {

        let hasAssignedItems = false;

        if (data === AssignedBalanceTransfer) {
          hasAssignedItems = data.some((item) =>
            item.transferFromBankStatementId === id || item.transferToBankStatementId === id
          );
          console.log('Balance transfer items:', data.map(item => ({
            id: item.id,
            transferFromBankStatementId: item.transferFromBankStatementId,
            transferToBankStatementId: item.transferToBankStatementId
          })));
        } else {
          hasAssignedItems = data.length > 0;
        }

        if (hasAssignedItems) {
          return unassignFn(id)
            .then(fetchFn)
            .then(refetchFn);
        } else {
          console.log('No assigned items found for ID:', id);
        }
      }
    );
    await Promise.all(tasks);

    await fetchAllBankstatements(year, month, selectedbank, search, currentPage, ITEMS_PER_PAGE, crDrFilter);
  };

  const handleCreateDonationClick = (id: string, bankId: string) => {
    setselectedbankstatementId(id);
    const matchingBank = banks.find((bank) => bank.id === bankId);
    if (!matchingBank) {
      console.warn("No matching bank found for bankId:", bankId);
      setmatchingDonationTypes([]);
      setmatchingDonationPurpose(undefined);
      return;
    }
    const matchingTPs = donationTP.filter(
      (item) => item.donationPurposeId === matchingBank.donationPurposeId
    );
    const matchedDonationTypes = donationtype.filter((dt) =>
      matchingTPs.some((tp) => tp.donationTypeId === dt.id)
    );
    setmatchingDonationTypes(matchedDonationTypes);
    const matchingPurpose = donationpurpose.find(
      (dp) => dp.id === matchingBank.donationPurposeId
    );
    setmatchingDonationPurpose(matchingPurpose);
  };

  const handleCreateOptionClick = (option: string, bankStatementId: string, crdr: string) => {
    setSelectedCreateOption(option);
    if (option === 'balanceTransfer' && crdr === 'DR') {
      setselectedbankstatementId(null);
      setdrbankstatementId(bankStatementId)
    } else {
      setselectedbankstatementId(bankStatementId);
      setdrbankstatementId(null)
    }
    setcreatemodal(true);
    setOpenDropdownId(null);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    fetchAllBankstatements(year, month, selectedbank, search, page, ITEMS_PER_PAGE, crDrFilter);
  };


  return (
    <div className=" h-full px-2 md:px-4 bg-[#ffff]">
      <div className='flex flex-row items-center'>
        <h2 className="text-3xl font-bold text-blue-600 mt-6 ">Bank Statement</h2>
        <button
          type="button"
          className=" w-fit px-3 py-2 mx-3 mt-6 tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
          onClick={() => {
            setEditingId(null);
            setAdd(true);
            setIsUploadPanelOpen(false);
          }}
        >
          <FaPlus className="w-3 h-3" />
        </button>
        <button
          onClick={() => {
            setIsUploadPanelOpen(true);
            setAdd(false);
          }}
          className=" w-fit px-3 py-1 mx-1 mt-6 tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
        >
          <IconUpload className="w-5 h-5" />
          {/* Upload */}
        </button>
      </div>
      {/* {search} */}
      <div className="flex flex-row gap-2 w-full mt-5">
        <div className="mb-4 w-full">
          <input
            type="text"
            placeholder="Search Expenses"
            className="w-full mb-4 p-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-500 border-gray-300"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div
          className="flex flex-row gap-1 justify-center px-1 py-2 h-10 w-[90px] hover:bg-gray-100 rounded-md cursor-pointer"
          onClick={() => setfilterModal(true)}
        >
          <VscFilter className="text-blue-500 h-7 w-7" />
          <span className="text-lg font-normal text-gray-600">Filter</span>
        </div>
      </div>

      <div className="flex-grow ml-0 mt-4 w-full">
        <div className="overflow-x-auto">
          {/* table */}
          <div className="border border-gray-200 dark:border-gray-700 md:rounded-lg">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
              <thead className="bg-gray-50 dark:bg-gray-800">
                <tr>
                  <th
                    scope="col"
                    className="px-4 py-3.5 text-md font-normal text-left text-gray-500 dark:text-gray-400"
                  ></th>
                  <th
                    scope="col"
                    className="px-4 py-3.5 text-md font-normal text-left text-gray-500 dark:text-gray-400"
                  >
                    Bank
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3.5 text-md font-normal text-left text-gray-500 dark:text-gray-400"
                  >
                    Type
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3.5 text-md font-normal text-left text-gray-500 dark:text-gray-400"
                  ></th>
                  <th
                    scope="col"
                    className="px-4 py-3.5 text-md font-normal text-left text-gray-500 dark:text-gray-400"
                  >
                    Amount
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3.5 text-md font-normal text-left text-gray-500 dark:text-gray-400"
                  >
                    Value Date
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3.5 text-md font-normal text-left text-gray-500 dark:text-gray-400"
                  >
                    ChequeNo
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3.5 text-md font-normal text-left text-gray-500 dark:text-gray-400"
                  >
                    Description
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3.5 text-md font-normal text-left text-gray-500 dark:text-gray-400"
                  >Status</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200 dark:divide-gray-700 dark:bg-gray-900">
                {bankStatements.length === 0 ? (
                  <tr>
                    <td colSpan={10} className="px-4 py-4 text-center text-gray-500">
                      No data found
                    </td>
                  </tr>
                ) : (
                  bankStatements.map((bankstatement: any) => (
                    <React.Fragment key={bankstatement.id}>
                      <tr>
                        <td className="px-4 py-4 text-sm whitespace-nowrap">
                          <div className="flex items-center gap-x-2">
                            <button
                              onClick={() => {
                                handleToggleExpand(
                                  bankstatement.id,
                                  bankstatement.cR_DR
                                );
                                if (bankstatement.cR_DR === "CR") {
                                  setCRstatementId(bankstatement.id);
                                  setDRstatementId('');
                                } else if (bankstatement.cR_DR === "DR") {
                                  setDRstatementId(bankstatement.id);
                                  setCRstatementId('');
                                }
                              }}
                            >
                              {(DebitedId === bankstatement.id &&
                                bankstatement.cR_DR === "DR") ||
                                (CreditId === bankstatement.id &&
                                  bankstatement.cR_DR === "CR") ? (
                                <SlArrowDown />
                              ) : (
                                <SlArrowRight />
                              )}
                            </button>
                          </div>
                        </td>
                        <td className="px-4 py-4 text-sm font-medium text-gray-500">
                          {bankstatement.bank}
                        </td>
                        <td className="px-4 py-4 text-sm font-medium text-gray-500">
                          {bankstatement.cR_DR}
                        </td>
                        <td className="px-4 py-4 text-sm font-medium text-gray-500">
                          <div className=" text-left">
                            <div>
                              <button
                                type="button"
                                className="p-2 rounded-md hover:bg-gray-100"
                                onClick={(e) => {
                                  toggleDropdown(bankstatement.id);
                                }}
                                id="menu-button"
                                aria-expanded={
                                  openDropdownId === bankstatement.id
                                }
                                aria-haspopup="true"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="w-3 h-5"
                                  viewBox="0 0 448 512"
                                >
                                  <path d="M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z" />
                                </svg>
                              </button>
                            </div>
                            {openDropdownId === bankstatement.id && (
                              <div
                                className="absolute w-48 origin-top-right rounded-md bg-white ring-1 shadow-lg ring-black/5 focus:outline-hidden z-20"
                                role="menu"
                                aria-orientation="vertical"
                                aria-labelledby="menu-button"
                              >
                                <div
                                  className="py-1"
                                  role="none"
                                  ref={dropdownRef}
                                >
                                  {/*create*/}
                                  {bankstatement.isAssigned === false && (
                                    <div className="relative group">
                                      <div className="px-3">
                                        <button className="text-gray-500 transition-colors duration-200 dark:text-gray-300 focus:outline-none flex items-center  w-full hover:bg-slate-100 px-1 py-1 rounded gap-2">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-tabler icons-tabler-outline icon-tabler-plus size-6"
                                          >
                                            <path
                                              stroke="none"
                                              d="M0 0h24v24H0z"
                                              fill="none"
                                            />
                                            <path d="M12 5l0 14" />
                                            <path d="M5 12l14 0" />
                                          </svg>
                                          <div className="flex items-center justify-between w-full">
                                            <span className="block px-1 py-1 text-sm font-medium text-gray-700">
                                              Create
                                            </span>
                                            <svg
                                              className="w-3 h-3 transition-transform"
                                              aria-hidden="true"
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                              viewBox="0 0 6 10"
                                            >
                                              <path
                                                stroke="currentColor"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                d="m1 9 4-4-4-4"
                                              />
                                            </svg>
                                          </div>
                                        </button>
                                      </div>

                                      <div className="absolute top-0 -ml-1 left-full z-20 bg-white rounded-md shadow-lg w-48 border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 transform translate-x-1">
                                        <div className="text-sm text-gray-700 dark:text-gray-200 py-1">
                                          {bankstatement.cR_DR === "CR" && (
                                            <>
                                              <div className="relative group/donation">
                                                <div
                                                  onMouseEnter={() =>
                                                    handleCreateDonationClick(
                                                      bankstatement.id,
                                                      bankstatement.bankId
                                                    )
                                                  }
                                                  className="cursor-pointer  w-full py-2 px-4 hover:bg-gray-50 font-medium transition-colors flex items-center justify-between rounded-md"
                                                >
                                                  <span className="block text-sm text-gray-700">
                                                    Donation
                                                  </span>
                                                  <svg
                                                    className="w-3 h-3 transition-transform"
                                                    aria-hidden="true"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 6 10"
                                                  >
                                                    <path
                                                      stroke="currentColor"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                      strokeWidth="2"
                                                      d="m1 9 4-4-4-4"
                                                    />
                                                  </svg>
                                                </div>

                                                <div className="absolute left-full top-0 ml-[2px] z-20 bg-white rounded-md shadow-lg w-48 border border-gray-100 opacity-0 invisible group-hover/donation:opacity-100 group-hover/donation:visible transition-all duration-200">
                                                  <ul className="py-1 max-h-60 overflow-y-auto">
                                                    {
                                                      matchingDonationTypes.map(
                                                        (type, index) => (
                                                          <li key={index}>
                                                            <div
                                                              className="cursor-pointer block px-4  py-2 text-sm hover:bg-gray-50 transition-colors rounded-md"
                                                              onClick={() => {
                                                                setSelectedDonationType(
                                                                  {
                                                                    id: type.id,
                                                                    name: type.name,
                                                                  }
                                                                );
                                                                handleCreateOptionClick(
                                                                  "donation",
                                                                  bankstatement.id,
                                                                  bankstatement.cR_DR
                                                                );
                                                              }}
                                                            >
                                                              {type.name}
                                                            </div>
                                                          </li>
                                                        )
                                                      )}
                                                    <li>
                                                      <div
                                                        className="cursor-pointer block px-4  py-2 text-sm hover:bg-gray-50 transition-colors rounded-md"
                                                        onClick={() => {
                                                          setSelectedDonationType({ id: null, name: "", });
                                                          handleCreateOptionClick(
                                                            "donation",
                                                            bankstatement.id,
                                                            bankstatement.cR_DR
                                                          );
                                                        }}
                                                      >
                                                        Unknown
                                                      </div>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </div>

                                              <div
                                                onClick={() =>
                                                  handleCreateOptionClick(
                                                    "balanceTransfer",
                                                    bankstatement.id,
                                                    bankstatement.cR_DR
                                                  )
                                                }
                                                className="flex items-center justify-between cursor-pointer w-full py-2 px-4 hover:bg-gray-50 font-medium transition-colors rounded-md"
                                              >
                                                <span className="block text-sm text-gray-700">
                                                  Balance Transfer
                                                </span>
                                              </div>
                                            </>
                                          )}

                                          {bankstatement.cR_DR === "DR" && (
                                            <>
                                              <div
                                                onClick={() =>
                                                  handleCreateOptionClick(
                                                    "Expense",
                                                    bankstatement.id,
                                                    bankstatement.cR_DR
                                                  )
                                                }
                                                className="flex items-center justify-between cursor-pointer w-full py-2 px-4 hover:bg-gray-50 font-medium transition-colors rounded-md"
                                              >
                                                <span className="block text-sm text-gray-700">
                                                  Expense
                                                </span>
                                              </div>
                                              <div
                                                onClick={() =>
                                                  handleCreateOptionClick(
                                                    "balanceTransfer",
                                                    bankstatement.id,
                                                    bankstatement.cR_DR
                                                  )
                                                }
                                                className="flex items-center justify-between cursor-pointer w-full py-2 px-4 hover:bg-gray-50 font-medium transition-colors rounded-md"
                                              >
                                                <span className="block text-sm text-gray-700">
                                                  Balance Transfer
                                                </span>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {/*Assign */}
                                  <div className="relative group">
                                    <div className="px-3">
                                      <button className="text-gray-500 transition-colors duration-200 dark:text-gray-300 focus:outline-none flex items-center  w-full hover:bg-slate-100 px-1 py-1 rounded gap-2">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          fill="none"
                                          viewBox="0 0 24 24"
                                          stroke-width="1.5"
                                          stroke="currentColor"
                                          className="size-6"
                                        >
                                          <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                          />
                                        </svg>

                                        <div className="flex items-center justify-between w-full">
                                          <span className="block px-1 py-1 text-sm font-medium text-gray-700">
                                            {isAlreadyAssigned(bankstatement.id)
                                              ? "Reassign"
                                              : "Assign"}
                                          </span>
                                          <svg
                                            className="w-3 h-3 transition-transform"
                                            aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 6 10"
                                          >
                                            <path
                                              stroke="currentColor"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              strokeWidth="2"
                                              d="m1 9 4-4-4-4"
                                            />
                                          </svg>
                                        </div>
                                      </button>
                                    </div>

                                    <div className="absolute top-0 -ml-1 left-full  z-20 bg-white rounded-md shadow-lg w-48 border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 transform translate-x-1">
                                      <div className="text-sm text-gray-700 dark:text-gray-200 py-1">
                                        {bankstatement.cR_DR === "CR" && (
                                          <>
                                            <div
                                              onClick={() =>
                                                handleAssignOptionClick(
                                                  "donation",
                                                  bankstatement.id,
                                                  bankstatement.transactionAmount,
                                                  bankstatement.cR_DR
                                                )
                                              }
                                              className="cursor-pointer w-full py-2 px-4 hover:bg-gray-50 font-medium transition-colors rounded-md"
                                            >
                                              <span className="block text-sm text-gray-700">
                                                Donation
                                              </span>
                                            </div>

                                            <div
                                              onClick={() =>
                                                handleAssignOptionClick(
                                                  "balanceTransfer",
                                                  bankstatement.id,
                                                  bankstatement.transactionAmount,
                                                  bankstatement.cR_DR
                                                )
                                              }
                                              className="cursor-pointer w-full py-2 px-4 hover:bg-gray-50 font-medium transition-colors rounded-md"
                                            >
                                              <span className="block text-sm text-gray-700">
                                                Balance Transfer
                                              </span>
                                            </div>
                                          </>
                                        )}

                                        {bankstatement.cR_DR === "DR" && (
                                          <>
                                            <div
                                              onClick={() =>
                                                handleAssignOptionClick(
                                                  "Expense",
                                                  bankstatement.id,
                                                  bankstatement.transactionAmount, bankstatement.cR_DR

                                                )
                                              }
                                              className="cursor-pointer w-full py-2 px-4 hover:bg-gray-50 font-medium transition-colors rounded-md"
                                            >
                                              <span className="block text-sm text-gray-700">
                                                Expense
                                              </span>
                                            </div>
                                            <div
                                              onClick={() =>
                                                handleAssignOptionClick(
                                                  "balanceTransfer",
                                                  bankstatement.id,
                                                  bankstatement.transactionAmount, bankstatement.cR_DR

                                                )
                                              }
                                              className="cursor-pointer w-full py-2 px-4 hover:bg-gray-50 font-medium transition-colors rounded-md"
                                            >
                                              <span className="block text-sm text-gray-700">
                                                Balance Transfer
                                              </span>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  {/*Edit */}
                                  <div className="px-3">
                                    <button
                                      onClick={() =>
                                        handleEditClick(bankstatement.id)
                                      }
                                      className="text-gray-500 transition-colors duration-200 dark:text-gray-300 focus:outline-none flex items-center  w-full hover:bg-slate-100 px-1 py-1 rounded gap-2"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke-width="1.5"
                                        stroke="currentColor"
                                        className="w-5 h-5"
                                      >
                                        <path
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                          d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                                        />
                                      </svg>
                                      <div
                                        className="block px-1 py-1 text-sm text-gray-700"
                                        role="menuitem"
                                        id="menu-item-0"
                                      >
                                        Edit
                                      </div>
                                    </button>
                                  </div>
                                  {/*Unassign */}
                                  <div className="px-3">
                                    <button
                                      onClick={() =>
                                        handleDeleteClick(bankstatement.id)
                                      }
                                      className="text-gray-500 transition-colors duration-200 dark:text-gray-300 focus:outline-none flex items-center  w-full hover:bg-slate-100 px-1 py-1 rounded gap-2"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke-width="1.5"
                                        stroke="currentColor"
                                        className="w-5 h-5"
                                      >
                                        <path
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                          d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                                        />
                                      </svg>
                                      <span className="block px-1 py-1 text-sm text-gray-700">
                                        UnAssign
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </td>
                        <td className="px-4 py-4 text-sm text-gray-500 whitespace-nowrap">
                          {bankstatement.transactionAmount}
                        </td>
                        <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                          {new Date(bankstatement.valueDate).toLocaleDateString(
                            "hi-IN",
                            {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            }
                          )}
                        </td>
                        <td className="px-4 py-4 text-sm font-medium text-gray-500">
                          {bankstatement.chequeNo}
                        </td>
                        <td className="px-4 py-4 text-sm font-medium text-gray-500">
                          {bankstatement.description}
                        </td>
                        <td className="px-4 py-4 text-sm font-medium text-gray-500">
                          {bankstatement.isAssigned ? "Assigned" : "Unassigned"}
                        </td>
                      </tr>
                      {DebitedId === bankstatement.id && (
                        <tr>
                          {AssignedBalanceTransfer.length > 0 ? (
                            <td colSpan={9}>
                              <BalanceTransferAssigned
                                url={url}
                                BalanceTransfer={AssignedBalanceTransfer}
                              />
                            </td>
                          ) : (
                            <td colSpan={9}>
                              <ExpensesAssigned
                                url={url}
                                Expenses={AssignedExpenses}
                              />
                            </td>
                          )}
                        </tr>
                      )}
                      {CreditId === bankstatement.id && (
                        <tr>
                          {AssignedBalanceTransfer.length > 0 ? (
                            <td colSpan={9}>
                              <BalanceTransferAssigned
                                url={url}
                                BalanceTransfer={AssignedBalanceTransfer}
                              />
                            </td>
                          ) : (
                            <td colSpan={9}>
                              <DonationAssigned
                                url={url}
                                Donations={AssignedDonations}
                               onSuccess={() => fetchAllBankstatements(year, month, selectedbank, search, currentPage, ITEMS_PER_PAGE, crDrFilter)}
                              />
                            </td>
                          )}
                        </tr>
                      )}
                    </React.Fragment>
                  )))}
              </tbody>
            </table>
          </div>
          {/* {add Panel} */}
          <SideModal isOpen={add} onClose={() => setAdd(false)}>
            <BankStatementForm
              url={url}
              add={add}
              setAdd={setAdd}
              Id={editingId}
              onSuccess={() => fetchAllBankstatements(year, month, selectedbank, search, currentPage, ITEMS_PER_PAGE, crDrFilter)}
            />
          </SideModal>

          {/* pagination */}
          <div className="flex items-center justify-between mt-6">
            <button
              disabled={currentPage === 1}
              onClick={() => handlePageChange(Math.max(currentPage - 1, 1))}
              className="flex items-center px-5 py-2 text-sm text-gray-700 capitalize transition-colors duration-200 bg-white border rounded-md gap-x-2 hover:bg-gray-100 dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-800"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-5 h-5 rtl:-scale-x-100"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
                />
              </svg>
              <span>Previous</span>
            </button>
            <div className="items-center hidden lg:flex gap-x-3">
              {Array.from({ length: Math.min(10, totalPages) }, (_, index) => {
                const startPage = Math.max(1, currentPage - 5);
                const page = startPage + index;
                if (page > totalPages) return null;
                return (
                  <button
                    key={page}
                    onClick={() => handlePageChange(page)}
                    className={`px-2 py-1 text-sm ${currentPage === page
                      ? "text-blue-500 bg-blue-100"
                      : "text-gray-500 hover:bg-gray-100"
                      } rounded-md`}
                  >
                    {page}
                  </button>
                );
              })}
            </div>
            <button
              onClick={() => handlePageChange(Math.min(currentPage + 1, totalPages))}
              disabled={currentPage === totalPages}
              className="flex items-center px-5 py-2 text-sm text-gray-700 capitalize transition-colors duration-200 bg-white border rounded-md gap-x-2 hover:bg-gray-100 dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-800"
            >
              <span>Next</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-5 h-5 rtl:-scale-x-100"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                />
              </svg>
            </button>
          </div>

          {/* Upload Panel */}
          <Filtermodal isOpen={isUploadPanelOpen} onClose={() => setIsUploadPanelOpen(false)}>
            <div className="px-4">
              <div className="flex justify-between items-center border-b pb-2 mb-4">
                <h3 className="text-xl font-semibold text-blue-700">
                  Upload Bank Statement
                </h3>
              </div>
              <label className="block mb-2">Select Bank</label>
              <select
                className="w-full p-2 border rounded mb-4"
                value={selectedbank}
                onChange={(e) => {
                  setSelectedBank(e.target.value);
                  setFile(null);
                }}
              >
                <option value="">-- Choose Bank --</option>
                {banks.map((bank) => (
                  <option key={bank.id} value={bank.id}>
                    {bank.name}
                  </option>
                ))}
              </select>
              <label className="block mb-2">Upload File</label>
              {selectedbank && (
                <p className="text-sm text-gray-600 mb-2">
                  {banks.find(bank => bank.id === selectedbank)?.name === "HDFC"
                    ? "Please select a .csv or .txt file for HDFC bank"
                    : "Please select a .psv file for this bank"}
                </p>
              )}
              <input
                type="file"
                accept={selectedbank ? (banks.find(bank => bank.id === selectedbank)?.name === "HDFC" ? ".csv,.txt" : ".psv") : ""}
                className={`w-full p-2 border rounded mb-4 ${!selectedbank ? 'opacity-50 cursor-not-allowed' : ''}`}
                disabled={!selectedbank}
                onChange={(e) =>
                  setFile(e.target.files ? e.target.files[0] : null)
                }
              />


              <div className="flex justify-start mt-4">
                <button
                  type="submit"
                  className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 mr-4"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
                <button
                  type="button"
                  className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-md"
                  onClick={handleResetForm}
                >
                  Cancel
                </button>
              </div>
            </div>
          </Filtermodal>

          {/* Filter Modal */}
          <Filtermodal isOpen={filterModal} onClose={() => setfilterModal(false)}>
            <div className="px-4 py-2">
              {/* Title Bar */}
              <div className="flex items-center justify-between border-b pb-2 mb-4">
                <h2 className="text-xl font-semibold text-blue-700">Bank Statement Filters</h2>

              </div>
              {/* Clear all */}
              <div className="flex items-center gap-4 mb-2">
                <button
                  onClick={handleClear}
                  className="flex items-center gap-2 text-blue-500 hover:underline hover:text-blue-700 text-sm font-medium focus:outline-none"
                >
                  <TbFilterX className="h-5 w-5" />
                  Clear all
                </button>
              </div>
              {/* Filter Fields */}
              <div className="grid grid-cols-1 gap-4 mt-2">
                {/* Bank selection */}
                <div>
                  <label className="text-sm font-semibold text-gray-900 mb-1 block flex items-center gap-1">
                    <span>Bank</span>
                  </label>
                  <select
                    id="donationType"
                    required
                    value={selectedbank}
                    onChange={(e) => setSelectedBank(e.target.value)}
                    className="w-full p-2 text-base text-gray-700 bg-white border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                  >
                    <option value="">All Banks</option>
                    {banks.map((bank) => (
                      <option key={bank.id} value={bank.id}>
                        {bank.name}
                      </option>
                    ))}
                  </select>
                </div>
                {/* CR/DR selection */}
                <div>
                  <label className="text-sm font-semibold text-gray-900 mb-1 block flex items-center gap-1">
                    <span>CR/DR</span>
                  </label>
                  <select
                    value={crDrFilter}
                    onChange={e => setCrDrFilter(e.target.value)}
                    className="w-full p-2 text-base text-gray-700 bg-white border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                  >
                    <option value="">All</option>
                    <option value="CR">CR</option>
                    <option value="DR">DR</option>
                  </select>
                </div>
                {/* Year selection */}
                <div>
                  <label className="text-sm font-semibold text-gray-900 mb-1 block flex items-center gap-1">
                    <span>Year</span>
                  </label>
                  <select
                    value={year}
                    onChange={(e) => {
                      setyear(e.target.value);
                      if (!e.target.value) {
                        setmonth('');
                      }
                    }}
                    className="w-full p-2 text-base text-gray-700 bg-white border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                  >
                    <option value="">Select Year</option>
                    {years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
                {/* Month selection */}
                <div>
                  <label className="text-sm font-semibold text-gray-900 mb-1 block flex items-center gap-1">
                    <span>Month</span>
                  </label>
                  <select
                    value={month}
                    onChange={(e) => setmonth(e.target.value)}
                    className="w-full p-2 text-base text-gray-700 bg-white border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                    disabled={!year}
                  >
                    <option value="">Select Month</option>
                    {months.map((month) => (
                      <option key={month} value={month}>
                        {month}
                      </option>
                    ))}
                  </select>
                </div>
                {/* Assigned/Unassigned selection */}
                <div>
                  <label className="text-sm font-semibold text-gray-900 mb-1 block flex items-center gap-1">
                    <span>Assignment Status</span>
                  </label>
                  <select
                    value={isAssigned === undefined ? '' : isAssigned ? 'assigned' : 'unassigned'}
                    onChange={e => {
                      if (e.target.value === '') setIsAssigned(undefined);
                      else if (e.target.value === 'assigned') setIsAssigned(true);
                      else setIsAssigned(false);
                    }}
                    className="w-full p-2 text-base text-gray-700 bg-white border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                  >
                    <option value="">All</option>
                    <option value="assigned">Assigned</option>
                    <option value="unassigned">Unassigned</option>
                  </select>
                </div>

              </div>
              {/* Divider */}
              <div className="border-t my-5" />
              {/* Actions */}
              <div className="flex gap-2 md:gap-4 justify-start">
                <button
                  className="px-4 py-2 text-white border border-blue-600 rounded bg-blue-500 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                  onClick={handleApply}
                >
                  Apply
                </button>
                <button
                  className="px-4 py-2 border border-gray-400 rounded bg-white hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-200 transition"
                  onClick={() => setfilterModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </Filtermodal>

          {/* assigning modals */}
          <SideModal isOpen={showDonationModel} onClose={() => setShowDonationModel(false)}>
            <DonationModel
              isOpen={showDonationModel}
              onClose={() => setShowDonationModel(false)}
              transactionAmount={currentTransactionAmount}
              bankstatementId={donationAssignId}
              Donations={Donations}
              fetchDonationData={(id: string, amount: number) => fetchDonationData(id, amount)}
              fetchAssignedDonationData={fetchAssignedDonationData}
              onSuccess={() => fetchAllBankstatements(year, month, selectedbank, search, currentPage, ITEMS_PER_PAGE, crDrFilter)}
            />
          </SideModal>
          <SideModal isOpen={showBalanceTransfer} onClose={() => setShowBalanceTransferModel(false)}>
            <BalanceTransferModel
              isOpen={showBalanceTransfer}
              onClose={() => setShowBalanceTransferModel(false)}
              transactionAmount={currentTransactionAmount}
              TransferFromBankstatementId={DrbalanceTransferAssignId}
              TransferToBankstatementId={CrbalanceTransferAssignId}
              BalanceTransfer={BalanceTransfer}
              fetchBalanceTransferData={(DrbalanceTransferAssignId: string, CrbalanceTransferAssignId: string, currentTransactionAmount: number) =>
                fetchBalanceTransferData(DrbalanceTransferAssignId, CrbalanceTransferAssignId, currentTransactionAmount)
              }
              fetchAssignedBalanceTransferData={fetchAssignedBalanceTransferData}
              onSuccess={() => fetchAllBankstatements(year, month, selectedbank, search, currentPage, ITEMS_PER_PAGE, crDrFilter)}
            />
          </SideModal>
          <SideModal isOpen={showExpensemodel} onClose={() => setShowExpenseModel(false)}>
            <ExpenseModel
              isOpen={showExpensemodel}
              onClose={() => setShowExpenseModel(false)}
              transactionAmount={currentTransactionAmount}
              bankstatementId={expenseAssignId}
              Expenses={Expenses}
              fetchExpensesData={(id: string, amount: number) => fetchExpensesData(id, amount)}
              fetchAssignedExpenseData={fetchExpenseData}
              onSuccess={() => fetchAllBankstatements(year, month, selectedbank, search, currentPage, ITEMS_PER_PAGE, crDrFilter)}
            />
          </SideModal>

          {/* creating modals */}
          <SideModal isOpen={selectedCreateOption === "donation" && createmodal} onClose={() => { setcreatemodal(false); setSelectedCreateOption(null); }}>
            {selectedCreateOption === "donation" && createmodal && (
              <DonationDetailForm
                url={url}
                statementId={selectbankstatementId}
                matchingDonationPurpose={matchingDonationPurpose}
                selectedDonationType={selectedDonationType}
                setAdd={setcreatemodal}
                onSuccess={() => fetchAllBankstatements(year, month, selectedbank, search, currentPage, ITEMS_PER_PAGE, crDrFilter)}
              // fetchAssignedDonationData={fetchDonationData}
              />
            )}
          </SideModal>
          <SideModal isOpen={selectedCreateOption === "Expense" && createmodal} onClose={() => { setcreatemodal(false); setSelectedCreateOption(null); }}>
            {selectedCreateOption === "Expense" && createmodal && (
              <ExpenseForm
                url={url}
                bankStatementId={selectbankstatementId}
                onSuccess={() => fetchAllBankstatements(year, month, selectedbank, search, currentPage, ITEMS_PER_PAGE, crDrFilter)}
                onClose={() => {
                  setcreatemodal(false);
                  setSelectedCreateOption(null);
                }}
              />
            )}
          </SideModal>
          <SideModal isOpen={selectedCreateOption === "balanceTransfer" && createmodal} onClose={() => { setcreatemodal(false); setSelectedCreateOption(null); }}>
            {selectedCreateOption === "balanceTransfer" && createmodal && (
              <BalanceTransferForm
                url={url}
                TransferToBankStatementId={selectbankstatementId}
                TransferFromBankStatementId={drbankstatementId}
                onClose={() => {
                  setcreatemodal(false);
                  setSelectedCreateOption(null);
                }}
              />
            )}
          </SideModal>

        </div>
      </div>
    </div >
  );
};
export default BankStatement;
